import configment from '@adc/configment'
import fetch from '@adc/fetch'
import userSerializer from '../serializers/user'

export default {
  login(email, password, loginEndPoint) {
    return fetch(loginEndPoint, {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({
        email,
        password,
      }),
    })
  },

  create(endpoint, user) {
    const body = userSerializer.create(user)

    return fetch(endpoint, {
      method: 'POST',
      body: JSON.stringify(body),
    })
  },

  investorPreferences(endpoint, questionSet) {
    return fetch(endpoint, {
      method: 'POST',
      body: questionSet,
    })
  },

  // TODO: Add to graph
  createSavedSearches(userId, saveSearchDTOs) {
    return fetch(
      `${configment.get(
        'RESI_MS_PROFILE'
      )}/resi/profile/v1/saved-searches/users/${userId}/generate`,
      {
        method: 'POST',
        body: saveSearchDTOs,
      }
    )
  },

  fetchBidderSignature() {
    return fetch.forAuctionGraph({
      query: `query toolkitAdc_bidderSignatureForCurrentUser {
          current_user {
            bidder_signature {
              ... on OnlineBidderSignature {
                current {
                  remaining_registration_count
                  auction_registration_count
                }
              }
            }
          }
        }`,
    })
  },
}
